import React from 'react';
import {App as AntdApp, ConfigProvider} from 'antd';
import {QueryClientProvider} from '@tanstack/react-query';
import {Provider} from 'react-redux';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {RootNavigator} from '@app/navigations';
import {PrimaryTheme} from '@app/style';
import configureStore from '@app/redux/store/configureStore';
import {getQueryClient} from '@app/reactQuery/rqClient';
import MainProvider from '@app/navigations/provider/MainProvider';
import GlobalComponent from '@app/components/global/GlobalComponent';
import {ToastContainer} from 'react-toastify';
import './App.less';

const store = configureStore();

const App = () => {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <Provider store = {store}>
        <ConfigProvider theme={PrimaryTheme}>
          <MainProvider>
            <AntdApp>
              <GlobalComponent />
              <RootNavigator />
              <ReactQueryDevtools />
              <ToastContainer />
            </AntdApp>
          </MainProvider>
        </ConfigProvider>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
